// extracted by mini-css-extract-plugin
module.exports = {"wrap":"We","articleImagesWrap":"Xe","articleImage":"Ye","singleImage":"Ze"};